export var LOG_IN_PROCESS_REQUEST = 'LOG_IN_PROCESS_REQUEST';
export var LOG_IN_PROCESS_SUCCESS = 'LOG_IN_PROCESS_SUCCESS';
export var LOG_IN_PROCESS_FAILURE = 'LOG_IN_PROCESS_FAILURE';
export var LOG_IN_REQUEST = 'LOG_IN_REQUEST';
export var LOG_IN_SUCCESS = 'LOG_IN_SUCCESS';
export var LOG_IN_FAILURE = 'LOG_IN_FAILURE';
export var LOG_OUT_REQUEST = 'LOG_OUT_REQUEST';
export var LOG_OUT_SUCCESS = 'LOG_OUT_SUCCESS';
export var LOG_OUT_FAILURE = 'LOG_OUT_FAILURE';
export var FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export var FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export var FORGOT_PASSWORD_FAILURE = 'FORGOT_PASSWORD_FAILURE';
export var DECODE_TOKEN_REQUEST = 'DECODE_TOKEN_REQUEST';
export var DECODE_TOKEN_SUCCESS = 'DECODE_TOKEN_SUCCESS';
export var DECODE_TOKEN_FAILURE = 'DECODE_TOKEN_FAILURE';
export var REFRESH_TOKEN_REQUEST = 'REFRESH_TOKEN_REQUEST';
export var REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS';
export var REFRESH_TOKEN_FAILURE = 'REFRESH_TOKEN_FAILURE';
export var RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export var RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export var RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';
export var USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST';
export var USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
export var USER_REGISTER_FAILURE = 'USER_REGISTER_FAILURE';
export var READ_USER_DETAILS_REQUEST = 'READ_USER_DETAILS_REQUEST';
export var READ_USER_DETAILS_SUCCESS = 'READ_USER_DETAILS_SUCCESS';
export var READ_USER_DETAILS_FAILURE = 'READ_USER_DETAILS_FAILURE';
export var USER_VERIFY_REQUEST = 'USER_VERIFY_REQUEST';
export var USER_VERIFY_SUCCESS = 'USER_VERIFY_SUCCESS';
export var USER_VERIFY_FAILURE = 'USER_VERIFY_FAILURE';
export var SWITCH_TO_REQUEST = 'SWITCH_TO_REQUEST';
export var SWITCH_TO_SUCCESS = 'SWITCH_TO_SUCCESS';
export var SWITCH_TO_FAILURE = 'SWITCH_TO_FAILURE';
export var SELF_REGISTER_REQUEST = 'SELF_REGISTER_REQUEST';
export var SELF_REGISTER_SUCCESS = 'SELF_REGISTER_SUCCESS';
export var SELF_REGISTER_FAILURE = 'SELF_REGISTER_FAILURE';
export var SUBMIT_SELF_REGISTRATION_REQUEST = 'SUBMIT_SELF_REGISTRATION_REQUEST';
export var SUBMIT_SELF_REGISTRATION_SUCCESS = 'SUBMIT_SELF_REGISTRATION_SUCCESS';
export var SUBMIT_SELF_REGISTRATION_FAILURE = 'SUBMIT_SELF_REGISTRATION_FAILURE';
export var CLEAR_LOGIN_FORM = 'CLEAR_LOGIN_FORM';